import { FinancialItem } from "../models/FinancialItem";
import { Comment } from "../models/Comment";
import api from "./api";

export const FinancialItemService = {
  async getFinancialItems(matterId: string): Promise<FinancialItem[]> {
    const res = await api.get(`/api/v1/financial-items`, {
      params: { matterId },
    });
    return res.data?.data ?? [];
  },

  async getFinancialItem(financialItemId: string): Promise<FinancialItem> {
    const res = await api.get(`/api/v1/financial-items/${financialItemId}`);
    return res.data?.data;
  },

  async createFinancialItem(
    financialItem: Partial<FinancialItem>,
  ): Promise<string> {
    const res = await api.post("/api/v1/financial-items", financialItem);
    return res.data?.data?._id;
  },

  async updateFinancialItem(
    financialItemId: string,
    financialItemData: Partial<Omit<FinancialItem, "_id">>,
  ): Promise<void> {
    await api.put(
      `/api/v1/financial-items/${financialItemId}`,
      financialItemData,
    );
  },

  async deleteFinancialItem(
    matterId: string,
    financialItemId: string,
  ): Promise<void> {
    await api.delete(`/api/v1/financial-items/${financialItemId}`, {
      params: { matterId },
    });
  },

  async getComments(financialItemId: string): Promise<Comment[]> {
    const res = await api.get(
      `/api/v1/financial-items/${financialItemId}/comments`,
    );
    return res.data?.data ?? [];
  },
};
